import { Statistic, Tooltip } from 'antd';
import React, { useState } from 'react';
import { Config } from '../../../../Config';
import { caculateTAX, caculateTDS } from '../../../../utils';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import './CampSubmitCard.styles.scss';

const CampSubmitCard = ({ children, balance, budget }) => {
  const [taxing, setTaxing] = useState({
    baseAmount: budget,
    gst: caculateTAX(budget, Config.payment.tax.roi_gst),
    tds: caculateTDS(budget, Config.payment.tax.roi_tds),
  });
  useState(()=>{
    setTaxing({
      ...taxing,
      netCost: (taxing.baseAmount + taxing.gst) - taxing.tds,
    });
  }, [budget, balance]);
  return (
    <div className="submissionCard">
      <ul className="mb-3 cc_preview_each_basics submissionCard_details d-flex justify-content-between">
        <li className="mr-1">
          <h6 className="d-block">{parseInt(budget)}</h6>
          <p className="d-block">Proposed Budget</p>
        </li>
        <li className={`ml-1 mr-0 ${(balance >= taxing.netCost) ? 'success' : 'error'}`}>
          <Tooltip title={(balance >= taxing.netCost) ? 'You have enough balance' : 'Please consider buying credits'}>
            <h6 className="d-block">{balance.toFixed(2)}</h6>
            <p className="d-block">Available Balance</p>
          </Tooltip>
        </li>
      </ul>
      <div className="cost_info mb-3">
        <div className="d-flex">
          <span>Campaign cost:</span>
          <span>{taxing.baseAmount}</span>
        </div>
        <div className="d-flex text-secondary">
          <span className="child_type">[+] IGST @18%:</span>
          <span>{taxing.gst}</span>
        </div>
        <div className="d-flex">
          <span className="text-success child_type">[-] TDS @10%:</span>
          <span className="text-success">{taxing.tds}</span>
        </div>
        <hr className="my-1"/>
        <div className="d-flex pt-1">
          <span><strong>Net Payable:</strong></span>
          <span>
            <strong><Statistic className="custom_number_format"
              value={taxing.netCost}
              precision={2}
              prefix={CurrencyIcon()}/></strong>
          </span>
        </div>
      </div>
      {children}
    </div>
  );
};

export default CampSubmitCard;
